import React, { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebaseConfig/firebase';
import { Container, Spinner, Card } from 'react-bootstrap';

import Header from './Header';
// Importa tus componentes aquí (asegúrate de que las rutas sean correctas)
 import FormInfo from './FormInfo';
 import Form from './Form';

function HomeAlumno({ handleLogout, email }) {
    const [loading, setLoading] = useState(true);
    const [permisos, setPermisos] = useState({ activo: false, activo_info: false });

    useEffect(() => {
        // Referencia al documento 'control' en la colección 'tribu-form-control'
        const docRef = doc(db, 'tribu-form-control', 'control');

        // Suscripción en tiempo real
        const unsubscribe = onSnapshot(docRef, (docSnap) => {
            if (docSnap.exists()) {
                const data = docSnap.data();
                setPermisos({
                    activo: data.activo || false,
                    activo_info: data.activo_info || false
                });
            } else {
                console.warn("El documento de control no existe en Firestore.");
            }
            setLoading(false);
        });

        // Limpiar la suscripción cuando el componente se desmonte
        return () => unsubscribe();
    }, []);

    if (loading) {
        return (
            <Container className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                <Spinner animation="border" variant="primary" />
            </Container>
        );
    }

    return (
        <>
            <Header handleLogout={handleLogout} />
            
            <Container className="mt-4">
                {/* Lógica de Renderizado Condicional */}
                
                {permisos.activo_info && (
                    <div className="mb-4">
                        <FormInfo />
                    </div>
                )}

                {permisos.activo && (
                    <div className="mb-4">
                        <Form />
                    </div>
                )}

                {!permisos.activo && !permisos.activo_info && (
                    <Card className="text-center p-5">
                        <Card.Body>
                            <Card.Title>No hay formularios activos</Card.Title>
                            <Card.Text>Vuelve más tarde para revisar si hay nuevas actividades.</Card.Text>
                        </Card.Body>
                    </Card>
                )}
            </Container>
        </>
    );
}

export default HomeAlumno;